export const counterProductKeywordStyle = theme => ({
    contentCount: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
})